export const RentalClass = {
    /** 즉시결제 */
    ORIGINAL_PAYMENT: 'ORIGINAL_PAYMENT',
    /** 수기결제 */
    MANUAL_PAYMENT: 'MANUAL_PAYMENT',
    /** 정기결제 */
    SCHEDULED_PAYMENT: 'SCHEDULED_PAYMENT',
} as const

export type RentalClassType = Constant<typeof RentalClass>

export const Channel = {
    CHARGE_TYPE: 'CHARGE_TYPE',
    PAY_TYPE: 'PAY_TYPE',
    CASH_ONLY: 'CASH_ONLY',
    BIO_AUTH: 'BIO_AUTH',
} as const

export type LogLevelType = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'FATAL'

export const PageSet = {
    // ORDERSHEET
    BLOG_RESULT: 'BLOG_RESULT',
    /** 배송조회 */
    DELIVERY_TRACKING: 'DELIVERY_TRACKING',
    EASY_BOOK_CHECKOUT: 'EASY_BOOK_CHECKOUT',
    EASY_BOOK_RESULT: 'EASYBOOK_RESULT',
    FAMILY_PAY_CHECKOUT: 'FAMILY_PAY_CHECKOUT',
    FLEA_MARKET_RESULT: 'FLEA_MARKET_RESULT',
    LOCAL_PAY_RESULT: 'LOCAL_PAY_RESULT',
    MALL_CHECKOUT: 'MALL_CHECKOUT',
    MALL_RESULT: 'MALL_RESULT',
    ORDER_DETAIL: 'ORDER_DETAIL',
    PAYMENT_METHOD_MANAGEMENT: 'PAYMENT_METHOD_MANAGEMENT',
    PURCHASE_CONFIRMATION: 'PURCHASE_CONFIRMATION',
    SALE_HISTORY_DETAIL: 'SALE_HISTORY_DETAIL',
    SALE_HISTORY: 'SALE_HISTORY',
    SALE_SETTLEMENT_DETAIL: 'SALE_SETTLEMENT_DETAIL',
    SALE_SETTLEMENT: 'SALE_SETTLEMENT',
    SELLER_CHECKOUT: 'SELLER_CHECKOUT',
    SELLER_RESULT: 'SELLER_RESULT',
    CLAIM_REQUEST: 'CLAIM_REQUEST',
    CLAIM_EXCHANGE: 'CLAIM_EXCHANGE',
    CLAIM_PAYMENT: 'CLAIM_PAYMENT',
    CLAIM_RESULT: 'CLAIM_RESULT',
    CLAIM_DETAIL: 'CLAIM_DETAIL',

    // PAYMENT
    // 인증형 결제창
    PARTNERS_PAYMENT: 'PARTNERS_PAYMENT',
    // 디콘 단건 결제창
    DICON_PAYMENT: 'DICON_PAYMENT',
    // 결제형 단건결제
    NAVER_FINANCIAL_PAYMENT: 'NAVER_FINANCIAL_PAYMENT',
    // 결제형 정기결제
    NAVER_FINANCIAL_AUTO: 'NAVER_FINANCIAL_AUTO',
    // 결제상세
    PAYMENT_DETAIL: 'PAYMENT_DETAIL',
    // 포인트 받기
    RECEIVE_POINT: 'RECEIVE_POINT',
    // 요금 납부
    INVOICE: 'INVOICE',

    // PAYMENT_METHODS
    // 인증형 자동결제
    PARTNERS_AUTO: 'PARTNERS_AUTO',
    // 디컨 정기결제
    DICON_AUTO: 'DICON_AUTO',
    // 매장방문결제
    BOOKING: 'BOOKING',
    // 정기구독
    SHOPPING_SUBSCRIPTION: 'SHOPPING_SUBSCRIPTION',
    // 해피빈
    HAPPYBEAN: 'HAPPYBEAN',
    // NPAY_BIZ
    NPAY_BIZ_CHECKOUT: 'NPAY_BIZ_CHECKOUT',
    /** 방문택배예약 */
    BOOK_PARCEL_PICKUP: 'BOOK_PARCEL_PICKUP',
} as const

export type PageSetType = Constant<typeof PageSet>

/**
 * 주문서 앱 구분
 **/
export const OrderSheetPageSet = {
    /** 가맹점 */
    MALL: PageSet.MALL_CHECKOUT,
    /** 예약/로컬페이/블로그/카페 */
    EASYBOOKING: PageSet.EASY_BOOK_CHECKOUT,
    /** 스마트스토어 */
    SELLER: PageSet.SELLER_CHECKOUT,
    /** 패밀리 맴버십 승인 결제 */
    FAMILY_PAY: PageSet.FAMILY_PAY_CHECKOUT,
    /** 클레임 비용 결제 */
    CLAIM: PageSet.CLAIM_PAYMENT,
} as const

/** 주문서 앱 구분 타입 */
export type OrderSheetPageSetType = Constant<typeof OrderSheetPageSet>

/** 완료 앱 구분 */
export const ResultChannelGroup = {
    /** 가맹점 */
    MALL: 'MALL',
    /** 예약/로컬페이/블로그/카페 */
    EASYBOOKING: 'EASYBOOKING',
    /** 스마트스토어 */
    SELLER: 'SELLER',
} as const

/** 완료 앱 구분 타입 */
export type ResultChannelGroupType = Constant<typeof ResultChannelGroup>

/**
 * 기본 서비스 사용처
 * @deprecated common slice 의 Entry 사용 권장
 */
const DefaultEntry = {
    ETC: 'ETC',
} as const

/**
 * 서비스 사용처를 구분
 * - 디컨 진입 서비스
 * @deprecated common slice 의 Entry 사용 권장
 */
export const DiconEntry = {
    B612: 'B612',
    CHZZK_PRIME: 'CHZZK_PRIME',
    CHZZK: 'CHZZK',
    CLOVA_DUBBING: 'CLOVA_DUBBING',
    CLOVA_NOTE: 'CLOVA_NOTE',
    /** 네이버페이 대출 > 신용관리 서비스 */
    CREDIT_MANAGEMENT: 'CREDIT_MANAGEMENT',
    GIFT_CARD: 'GIFT_CARD',
    HAPPY_BEAN: 'HAPPY_BEAN',
    KIN: 'KIN',
    MY_GOLF: 'MY_GOLF',
    MYBOX: 'MYBOX',
    /** 네이버 비지니스 스쿨 */
    NAVER_BUSINESS_SCHOOL: 'NAVER_BUSINESS_SCHOOL',
    N_CLOUD: 'N_CLOUD',
    N_STORE: 'N_STORE',
    NAVER_GAME: 'NAVER_GAME',
    NAVER_MEMBERSHIP: 'NAVER_MEMBERSHIP',
    OGQ_MARKET: 'OGQ_MARKET',
    PAPAGO: 'PAPAGO',
    PREMIUM_CONTENTS: 'PREMIUM_CONTENTS',
    SEARCH_AD: 'SEARCH_AD',
    SERIES_EBOOK: 'SERIES_EBOOK',
    SERIES: 'SERIES',
    SNOW: 'SNOW',
    TAROTOON: 'TAROTOON',
    VIBE: 'VIBE',
    WEBTOON_AILABS: 'WEBTOON_AILABS',
    // 스노우 법인 비지니스 편집툴
    WIKIT: 'WIKIT',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type DiconEntryType = Constant<typeof DiconEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const PaymentMethodManagementEntry = {
    /** 예약/주문 자동결제 */
    BOOKING: 'BOOKING',
    /** 정기구독 */
    SUBSCRIPTION: 'SUBSCRIPTION',
    /** 패밀리결제 */
    FAMILY_PAY: 'FAMILY_PAY',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type PaymentMethodManagementEntryValues = Constant<typeof PaymentMethodManagementEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const OrderSheetEntry = {
    /** 1. 가맹점 - 네이버페이 가맹점 */
    CHECKOUT: 'CHECKOUT',
    /** 2. 예약/블로그/카페 - 네이버 예약 */
    EASY_BOOKING: 'EASY_BOOKING',
    /** 2. 예약/블로그/카페 - 테이블오더(v1, v2) */
    LOCAL_PAY: 'LOCAL_PAY',
    /** 2. 예약/블로그/카페 - 네이버 까페(v1) */
    NAVER_CAFE: 'NAVER_CAFE',
    /** 주문완료에서는 네이버카페가 아래와 같이 내려온다 수정 요청 필요 */
    NAVERCAFE: 'NAVERCAFE',
    /** 플리마켓(카페) 구매자보호 수수료 */
    FLEA_MARKET: 'FLEA_MARKET',
    /** 2. 예약/블로그/카페 - 네이버 블로그(v2) */
    NAVER_BLOG: 'NAVER_BLOG',
    /** 주문완료에서는 블로그가 아래와 같이 내려옴 */
    NAVERBLOG: 'NAVERBLOG',
    /** 3. 스마트스토어 */
    SHOPN: 'SHOPN',
    /** 3. 스마트스토어 - 선물하기 */
    GIFTING: 'GIFTING',
    /** 3. 스마트스토어 - 장보기 */
    BRANCH: 'BRANCH',
    /** 4. 패밀리 결제 */
    FAMILY_PAY: 'FAMILY_PAY',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type OrderSheetEntryType = Constant<typeof OrderSheetEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const ScheduledOrderEntry = {
    /** 정기구독 */
    SUBSCRIPTION: 'SUBSCRIPTION',
    /** 주문형 해피빈 */
    HAPPY_BEAN_ORDER: 'HAPPY_BEAN',
    /** 그룹구매 */
    GROUP_PURCHASE: 'GROUP_PURCHASE',
    /** 렌탈 */
    RENTAL: 'RENTAL',
    /** 매장방문결제 */
    POST_PAYMENT: 'POST_PAYMENT',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type ScheduledOrderEntryType = Constant<typeof ScheduledOrderEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */

export const OrderEntry = {
    ...OrderSheetEntry,
    ...PaymentMethodManagementEntry,
    ...ScheduledOrderEntry,
    ...DefaultEntry,
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type OrderEntryType = Constant<typeof OrderEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const PartnersEntry = {
    WETAX: 'WETAX',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type PartnersEntryType = Constant<typeof PartnersEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const PaymentDetailEntry = {
    /** 결제형 단건 */
    PAYMENT_DETAIL_NORMAL: 'PAYMENT_DETAIL_NORMAL',
    /** 결제형 자동 */
    PAYMENT_DETAIL_RECURRENT: 'PAYMENT_DETAIL_RECURRENT',
    /** 인증형 단건 */
    PAYMENT_DETAIL_AUTH: 'PAYMENT_DETAIL_AUTH',
    /** 인증형 자동 */
    PAYMENT_DETAIL_AUTH_AUTOMATIC: 'PAYMENT_DETAIL_AUTH_AUTOMATIC',
    /** 현장결제 */
    PAYMENT_DETAIL_OFFLINE: 'PAYMENT_DETAIL_OFFLINE',
    /** 자체가맹점 */
    PAYMENT_DETAIL_INSTORE: 'PAYMENT_DETAIL_INSTORE',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type PaymentDetailEntryType = Constant<typeof PaymentDetailEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const InvoiceEntry = {
    INVOICE: 'INVOICE',
} as const

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type InvoiceEntryType = Constant<typeof InvoiceEntry>

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export const Entry = {
    ...DiconEntry,
    ...OrderEntry,
    ...ScheduledOrderEntry,
    ...PartnersEntry,
    ...PaymentDetailEntry,
    ...InvoiceEntry,
    ...DefaultEntry,
}

/**
 * @deprecated common slice 의 Entry 사용 권장
 */
export type EntryType = Constant<typeof Entry>

export const UserAuthStatus = {
    /** 비회원 */
    ANONYMOUS: 'ANONYMOUS',
    /** 인증회원 */
    CERTIFICATE: 'CERTIFICATE',
} as const

export type UserAuthStatusType = Constant<typeof UserAuthStatus>

export const ScheduledChannel = {
    SUBSCRIPTION: 'SUBSCRIPTION',
    HAPPY_BEAN: 'HAPPY_BEAN',
    GROUP_PURCHASE: 'GROUP_PURCHASE',
    RENTAL: 'RENTAL',
    API_TEST_ORDER: 'API_TEST_ORDER',
    POST_PAYMENT: 'POST_PAYMENT',
    FAMILY_PAY: 'FAMILY_PAY',
} as const

export type ScheduledChannelType = Constant<typeof ScheduledChannel>
